import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const banksApi = createAsyncThunk(
  "banks",
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};

    // Add name to the query if provided
    if (name) {
      params.name = name;
    }

    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axiosInstance.get("/banks", {
      params, // Pass the parameters to the API request
    });
    return response.data;
  }
);

const banksSlice = createSlice({
  name: "banks",
  initialState: {
    banks: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(banksApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(banksApi.fulfilled, (state, action) => {
        state.banks = action.payload;
        state.loading = false;
      })
      .addCase(banksApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default banksSlice.reducer;
